import React from "react";
import { Typography } from "@mui/material";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { DownloadCustomerOrders } from "./DownloadCustomerOrders";
import { UploadCustomerOrders } from "./UploadCustomerOrders";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3, pl: 0 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `tab-${index}`,
    "aria-controls": `tabpanel-${index}`,
  };
}

export const UploadCustomerDemands = () => {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
    <div className="mainPageStyling">
      <Typography component="h1" variant="h5">
        Download and Upload File to Amend/Cancel Third-party Customer Orders
      </Typography>
      <Typography variant="subtitle2">
        If you need to make changes or cancel an order placed by third-party
        customer, simply download the file, complete the necessary
        modifications, and upload the updated file to the system. If you already
        have the file, you can upload it with required changes directly.
      </Typography>
      <Box sx={{ width: "100%", mt: 2, pl: 0 }}>
        <Box
          sx={{ borderBottom: 2, borderColor: "primary", height: "1.76rem" }}
        >
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="customer demand tabs"
            textColor="primary.contrastText"
            sx={{
              minHeight: "1rem",
              "& button": {
                backgroundColor: "secondary.light",
                fontWeight: "bold",
                width: "10vw",
                minHeight: "1.6rem",
                p: ".3em 0",
                fontSize: "0.7rem",
              },

              "& .Mui-selected": {
                backgroundColor: "primary.main",
                color: "white",
              },
            }}
          >
            <Tab label="Download" {...a11yProps(0)} />
            <Tab label="Upload" {...a11yProps(1)} />
          </Tabs>
        </Box>
        <TabPanel value={value} index={0} component="div">
          <DownloadCustomerOrders />
        </TabPanel>
        <TabPanel value={value} index={1} component="div">
          <UploadCustomerOrders />
        </TabPanel>
      </Box>
      </div>
    </>
  );
};
